import React from 'react';
import { ColumnItem } from '../column-item';
import { ImageContent } from './image-content';
export function Image(props) {
    const { align = 'center', cssClass, href, padding = '10px 25px', src, altText, } = props;
    return (React.createElement(ColumnItem, { align: align, padding: padding, cssClass: cssClass },
        React.createElement(ImageContent, { src: src, href: href, altText: altText })));
}
//# sourceMappingURL=image.js.map